<template>
  <div class="diseaseList">
    <el-card class="box-card" v-if="active === 0">
      <div>账号：{{ userInfo.username }} (可联系管理员修改)</div>
      <div>密码: (已加密)</div>
      <div>
        手机号：{{ userInfo.phone ? userInfo.phone : "暂无" }}
      </div>
      <div>创建日期：{{ userInfo.createTime }}</div>
      <!-- <div>最近登录：{{ userInfo.updateTime?userInfo.updateTime:'暂未登录' }}</div> -->
    </el-card>
    <div style="margin: 20px 0">
      <el-button
        style="padding: 8px 10px; margin-right: 10px"
        @click="dialogVisible = true"
        v-waves
        >修改密码</el-button
      >
      <el-button
        style="padding: 8px 10px"
        @click="goToHome"
        v-waves
        type="primary"
        >返回主页</el-button
      >
<!--      <el-button-->
<!--        style="padding: 8px 10px; margin-left: 10px"-->
<!--        @click="runDoctorsSyncMock"-->
<!--        v-waves-->
<!--        type="success"-->
<!--        :loading="allocatingPf"-->
<!--        >模拟医生同步</el-button-->
<!--      >-->
    </div>



    <!-- 弹窗表单 -->
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      :z-index="3000"
      style="width: 70rem;"
    >
      <el-form ref="form" :model="dialogForm" label-width="100px">
        <el-form-item label="原密码" required>
          <el-input clearable v-model="dialogForm.oldPassword"></el-input>
        </el-form-item>
        <el-form-item label="修改密码:" required>
          <el-input
            clearable
            v-model="dialogForm.password"
            placeholder="输入密码自动md5加密"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button
          class="addBtn"
          size="small"
          type="primary"
          @click="save"
          v-waves
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { loginOut } from "@/services/user/index";
import { updatePassword, processDoctorsMock } from "@/services/system/user.js";
export default {
  data() {
    return {
      active: 0,
      dialogVisible: false,
      dialogForm: {},
      allocatingPf: false,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    goToHome() {
      // 返回主页
      this.$router.push({ name: "ConsultationControl" });
    },
    async runDoctorsSyncMock() {
      this.allocatingPf = true;
      try {
        const res = await processDoctorsMock();
        if (res && (res.code === 200 || res.success)) {
          this.$message.success("已触发完整processDoctors流程，请查看后端日志和数据库结果");
        } else {
          this.$message.error((res && (res.message || res.result)) || "触发processDoctors失败");
        }
      } catch (e) {
        this.$message.error((e && e.message) || "触发processDoctors失败");
      } finally {
        this.allocatingPf = false;
      }
    },
    save() {
      if (!this.dialogForm.oldPassword || !this.dialogForm.password) {
        this.$message.error("请填写必填字段");
        return;
      }
      this.$confirm("此操作将覆盖之前的密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const result = await updatePassword({
            username: this.userInfo.username,
            oldPassword: this.dialogForm.oldPassword,
            newPassword: this.dialogForm.password,
          });
          if (result.code == 200) {
            this.$message({
              type: "success",
              message: "修改成功!",
            });
            this.dialogVisible = false;
            setTimeout(() => {
              this.$router.push({ name: "Login" });
              // 清除本地存储
              localStorage.removeItem('storeToken');
              localStorage.removeItem('loginTenantId');
              this.$message.success('已退出登录');

              // loginOut({ id: this.userInfo.id }).then(() => {
              //   this.$message({
              //     type: "success",
              //     message: "已注销登录!",
              //   });
              // });
            }, 800);
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.box-card {
  width: 480px;
  div {
    margin: 10px 0;
  }
}
</style>
